module.exports = "/images/visa.jpg?85bb0900a1c3bd5359bc4f28cad70194";


//////////////////
// WEBPACK FOOTER
// ./public/img/visa.jpg
// module id = a9ah
// module chunks = 5